<div class="card shadow-sm rounded-3">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="fw-bold text-dark m-0 d-flex align-items-center">
        <i class="la la-file-contract me-2"></i> {{ 'PROPERTY.TAB.CONTRACTS' | translate }}
      </h4>
      <button (click)="addContract()" class="btn btn-primary btn-sm py-2">
        <i class="las la-plus me-1"></i> {{ 'PROPERTY.ADD_CONTRACTS' | translate }}
      </button>
    </div>
    <p class="text-muted mt-2 mb-0">{{ 'APARTMENT.CONTRACT_DESCRIPTION' | translate }}</p>
    <div class="mt-4">
      <p-table
        [hasEdit]="false"
        [hasView]="false"
        [loading]="isLoading()"
        [paginator]="false"
        [rows]="4"
        [tableStyle]="{'min-width': '50rem'}"
        [value]="apartmentContracts"
        responsiveLayout="scroll"
        tableStyleClass="table table-hover custom-table"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width:20%">{{ 'PROPERTY.RENTER_PROVIDER' | translate }}</th>
            <th>{{ 'BUILD_DASHBOARD.UNIT' | translate }}</th>
            <th style="width: 17%">{{ 'APARTMENT.TYPE' | translate }}</th>
            <th>{{ 'PROPERTY.BEGIN' | translate }}</th>
            <th>{{ 'PROPERTY.END' | translate }}</th>
            <th>{{ 'PROPERTY.MONTHLY_RENT' | translate }}</th>
            <th>{{ 'READINGS.ACTIONS' | translate }}</th>
          </tr>
        </ng-template>

        <ng-template let-contract pTemplate="body">
          <tr>
            <td style="width:20%">{{ contract?.renter | renterName }}</td>
            <td>{{ contract.contract?.apartment?.name }}</td>
            <td style="width:17%">Rental Contract</td>
            <td>{{ contract.startDate }}</td>
            <td>{{ contract.endDate }}</td>
            <td>
              <span>{{ contract.amount }} <i class="la la-euro"></i></span>
            </td>
            <td>
              <a (click)="inProcess()" class="text-primary">
                <i class="pi pi-eye me-1"></i> Details
              </a>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="footer">
          <div class="d-flex justify-content-between align-items-center py-3">
            <p class="my-0 fw-semibold text-muted">
              {{ 'TOTAL' | translate }} {{ apartmentContracts.length }}
              {{ 'APARTMENT.CONTRACTS' | translate }}
            </p>
            <button class="btn btn-outline-primary px-3 btn-sm" routerLink="{{Resources.PropertyContracts}}">
              {{ 'PROPERTY.VIEW_ALL_CONTRACTS' | translate }}
            </button>
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
